import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "./alert-dialog";
import { AlertCircle, AlertTriangle, Info, CheckCircle } from "lucide-react";

const variantConfig = {
  danger: { icon: AlertCircle, iconColor: "text-red-400", btnClass: "bg-red-600 hover:bg-red-700 text-white" },
  warning: { icon: AlertTriangle, iconColor: "text-yellow-400", btnClass: "bg-yellow-600 hover:bg-yellow-700 text-white" },
  info: { icon: Info, iconColor: "text-blue-400", btnClass: "bg-blue-600 hover:bg-blue-700 text-white" },
  success: { icon: CheckCircle, iconColor: "text-green-400", btnClass: "bg-green-600 hover:bg-green-700 text-white" },
};

export function ConfirmActionDialog({
  open,
  onOpenChange,
  onConfirm,
  title = "Confirm Action",
  description = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "warning",
  loading = false,
}) {
  const config = variantConfig[variant] || variantConfig.warning;
  const Icon = config.icon;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-[#121212] border-[#262626] text-white max-w-md" data-testid="confirm-action-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className={`flex items-center gap-2 ${config.iconColor}`}>
            <Icon size={20} />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-[#A1A1AA] pt-2">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2 sm:gap-0">
          <AlertDialogCancel
            disabled={loading}
            className="border-[#333] text-[#A1A1AA] hover:bg-[#1A1A1A] bg-transparent"
            data-testid="confirm-action-cancel"
          >
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            disabled={loading}
            className={config.btnClass}
            data-testid="confirm-action-confirm"
          >
            {loading ? "Processing..." : confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
